import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../../css/bootstrap.min.css';
import '../../css/style.css';
import '../../css/admin-sidebar.css';
import AdminSidebar from "../Adminsidebar/AdminSidebar";
import logo from "../../../assets/img/logo.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons'; // Import FontAwesome icon

 const API_BASE_URL = process.env.API_BASE_URL || 'https://api.hitkarihospital.com:5005'; // Your backend API URL
function AddCarousel() {
  const [images, setImages] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [heading, setHeading] = useState('');
  const [paragraph, setParagraph] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [activeLink, setActiveLink] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [imagesPerPage, setImagesPerPage] = useState(6);
  const [searchTerm, setSearchTerm] = useState('');
   const [showAddModal, setShowAddModal] = useState(false); // Modal State


  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const handleLinkClick = (link) => {
    setActiveLink(link);
  };

  useEffect(() => {
    fetchCarouselImages();
  }, []);

  const fetchCarouselImages = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_BASE_URL}/carousel-images`);
      
      setImages(response.data);
      setError('');
    } catch (err) {
      setError('Error fetching carousel images: ' + err.message);
      setImages([]);
    } finally {
      setLoading(false);
    }
  };

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    if (!selectedFile ) {
      setMessage('Please provide image');
      return;
    }

    const formData = new FormData();
    formData.append('image', selectedFile);
    formData.append('heading', heading);
    formData.append('paragraph', paragraph);

    try {
      const response = await axios.post(`${API_BASE_URL}/upload-carousel`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setMessage(response.data.message);
      setSelectedFile(null);
      setHeading('');
      setParagraph('');
      setShowAddModal(false); // Close the modal on successful upload
      fetchCarouselImages();
    } catch (err) {
      setMessage('Error uploading image: ' + err.message);
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${API_BASE_URL}/images/${id}`);
      fetchCarouselImages();
      setMessage('Image deleted successfully');
    } catch (err) {
      setMessage('Error deleting image: ' + err.message);
    }
  };

  // Calculate indexes for pagination
  const indexOfLastImage = currentPage * imagesPerPage;
  const indexOfFirstImage = indexOfLastImage - imagesPerPage;

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1); // Reset to first page when searching
    };
  // Filter images based on search term
    const filteredImages = images.filter(image =>
        image.heading.toLowerCase().includes(searchTerm.toLowerCase()) ||
        image.paragraph.toLowerCase().includes(searchTerm.toLowerCase())
    );
  // Calculate images to display on current page
  const currentImages = filteredImages.slice(indexOfFirstImage, indexOfLastImage);

  // Change page
  const paginate = pageNumber => setCurrentPage(pageNumber);

   // Handler to change the number of images per page
    const handleImagesPerPageChange = (e) => {
        setImagesPerPage(parseInt(e.target.value, 10));
        setCurrentPage(1); // Reset to first page when changing images per page
    };
  // Generate page numbers for pagination
    const pageNumbers = [];
    for (let i = 1; i <= Math.ceil(filteredImages.length / imagesPerPage); i++) {
        pageNumbers.push(i);
    }

   const handleShowAddModal = () => {
        setShowAddModal(true);
    };

    const handleCloseAddModal = () => {
        setShowAddModal(false);
        setSelectedFile(null);
        setHeading('');
        setParagraph('');
        setMessage('');
    };

  return (
    <div className="main-wrapper">
       <div className="hitkari-main-wrapper">
<AdminSidebar/>     

      <div className="page-wrapper">
          <div className="content container-fluid">
              <div className="row">
                  <div className="col-sm-12">
                       
                  <div className="row align-items-center">
                            <div className="col">
                                <h3 className="page-title">Carousel</h3>
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item"><a href="index.html">Dashboard</a></li>
                                    <li className="breadcrumb-item active">Carousel</li>
                                </ul>
                            </div>
                            <div className="col-auto">
                                <button type="button" className="btn btn-primary" onClick={handleShowAddModal}>
                                    <i className="fas fa-plus"></i> Add Carousel
                                </button>
                            </div>
                        </div>

                      {message && <div className="alert alert-info">{message}</div>}
                      {error && <div className="alert alert-danger">{error}</div>}
                    
        {/* Search Input */}
        <div className="form-group">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search headings or paragraphs..."
                            value={searchTerm}
                            onChange={handleSearch}
                        />
                           <div className="col-12 d-flex justify-content-between align-items-center mt-3">
                        <div>
                            <label>Items per page:</label>
                            <select
                                className="form-control"
                                value={imagesPerPage}
                                onChange={(e) => setImagesPerPage(Number(e.target.value))}
                            >
                                <option value="3">3</option>
                                <option value="6">6</option>
                                <option value="9">9</option>
                                <option value="12">12</option>
                                <option value="50">50</option>
                            </select>
                        </div>

                               {/* Pagination */}
                                <nav aria-label="Page navigation">
                                    <ul className="pagination justify-content-center">
                                         {pageNumbers.map(number => (
                                                <li key={number} className="page-item">
                                                    <button onClick={() => paginate(number)} className="page-link">
                                                        {number}
                                                    </button>
                                                </li>
                                            ))}
                                    </ul>
                                </nav>
                        </div>
                    </div>
                    <div className="row custom-image-row">
  {loading ? (
    <p>Loading...</p>
  ) : (
    currentImages.map((image) => (
      <div className="col-md-2 custom-image-col" key={image._id}>
        <div className="card">
          <img
            src={`${API_BASE_URL}${image.path}`}
            className="card-img-top"
            alt="Carousel"
          />
          <div className="card-body">
            <button className="btn btn-danger btn-sm" onClick={() => handleDelete(image._id)}>
              Delete
            </button>
          </div>
        </div>
      </div>
    ))
  )}
</div>

                   </div>
                        
                </div>
            </div>

            {/* Modal for Adding Carousel Image */}
            {showAddModal && (
                <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-labelledby="addModalLabel" aria-hidden="true">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="addModalLabel">Add New Carousel Image</h5>
                                <button type="button" className="close" onClick={handleCloseAddModal} aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <form>
                                   
                                    <div className="form-group">
                                        <label>Select Image:</label>
                                        <input type="file" className="form-control" onChange={handleFileChange} />
                                    </div>
                                    <button type="button" className="btn btn-primary" onClick={handleUpload}>Upload</button>
                                    {message && <div className="mt-3 alert alert-info">{message}</div>}
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    </div>
    </div>
  );
}

export default AddCarousel;